import type { FC } from "react"
import React from "react"

import { useRecoilValue } from "recoil"

import { ErrorBoundary } from "~/components/ErrorBoundary"

import { InstallArea } from "./InstallArea"
import { areaIndex } from "../../../state/elements"

const InstallAreas_Internal: FC = () => {
  const areaIds = useRecoilValue(areaIndex)

  return (
    <>
      {areaIds.map((id, idx) => (
        <ErrorBoundary key={id} Fallback={() => <text>InstallArea broke</text>}>
          <InstallArea id={id} idx={idx} />
        </ErrorBoundary>
      ))}
    </>
  )
}

export const InstallAreas = React.memo(InstallAreas_Internal)
